import { createRoute, Link, redirect } from '@tanstack/react-router';
import { Route as rootRoute } from '../__root';
import { Layout } from '@/client/layouts/layout';
import { FileText } from 'lucide-react';
import { runbookPages } from '@/client/content/runbook';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: 'runbook',
  beforeLoad: async ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: RunbookIndexComponent,
});

function RunbookIndexComponent() {
  return (
    <Layout>
      <div>
        <h3 className="mb-4 text-2xl font-semibold">Runbook</h3>
        <p className="text-muted-foreground mb-6">
          Documentation and operational guides for the admin portal.
        </p>

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {runbookPages.map((page) => (
            <Link
              key={page.slug}
              to="/runbook/$page"
              params={{ page: page.slug }}
              className="flex items-center gap-3 p-4 rounded-lg border hover:bg-accent transition-colors"
            >
              <FileText className="h-5 w-5 text-muted-foreground" />
              <span className="font-medium">{page.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}
